export enum ApplicationCriticality {
    less_critical = 'less_critical',
    most_critical = 'most_critical',
    not_critical = 'not_critical',
    somewhat_critical = 'somewhat_critical'
}

export type ApplicationCriticalityOption = {
    title: string;
    value: ApplicationCriticality;
};

export const ApplicationCriticalityOptions: Array<ApplicationCriticalityOption> = [
    {
        title: 'Most critical',
        value: ApplicationCriticality.most_critical
    },
    {
        title: 'Somewhat critical',
        value: ApplicationCriticality.somewhat_critical
    },
    {
        title: 'Less critical',
        value: ApplicationCriticality.less_critical
    },
    {
        title: 'Not critical',
        value: ApplicationCriticality.not_critical
    }
];

export const applicationCriticalityByValue: Record<ApplicationCriticality, ApplicationCriticalityOption> = {
    [ApplicationCriticality.most_critical]: ApplicationCriticalityOptions[0],
    [ApplicationCriticality.somewhat_critical]: ApplicationCriticalityOptions[1],
    [ApplicationCriticality.less_critical]: ApplicationCriticalityOptions[2],
    [ApplicationCriticality.not_critical]: ApplicationCriticalityOptions[3]
};
